module.exports = __webpack_public_path__ + "img/verifiedTick.0779c19e.svg";